import classnames from 'classnames';
import React from 'react';
import {Link} from 'react-router';

import {callTargetedAction, useFluxStore} from 'client/framework';
import {drawerActions} from 'client/generic/Drawer/DrawerActions';
import sessionStore from 'client/Session/SessionStore';
import Drawer, {colorSchemes} from 'generic/Drawer/Drawer.react';

import {HelpCenterLink, HelpMenu} from '../NavWidgets/NavWidgets.react';
import useNavItems from '../useNavItems';

import './global-nav-drawer.scss';

const {DRAWER_SET_DRAWER_VISIBILITY} = drawerActions;

const GlobalNavDrawer = () => {
  const isStudent = useFluxStore(sessionStore, (s) => s.isStudent());
  const {getIsMatchingRoute, mainNavItems} = useNavItems();

  const handleOpenGlobalDrawer = () => {
    callTargetedAction({
      name: DRAWER_SET_DRAWER_VISIBILITY,
      payload: true,
      targetStore: 'GlobalNavDrawerStore'
    });
  };

  const toggleIconOnKeyPress = (e) => {
    if (e.which === 13) {
      handleOpenGlobalDrawer();
    }
  };

  return (
    <div className='global-nav-drawer' onClick={handleOpenGlobalDrawer} role='button' tabIndex={0}>
      <span
        className='global-nav-drawer__toggle'
        role='button'
        onKeyDown={toggleIconOnKeyPress}
        tabIndex={0}
      >
        Menu
      </span>
      <Drawer
        colorScheme={colorSchemes.BLUE}
        direction='left'
        hasCloseButton={false}
        drawerTitle='Menu'
        storeName='GlobalNavDrawerStore'
      >
        <div className='global-nav-drawer__links-wrapper'>
          {mainNavItems.map((navItem) => {
            const isMatchingRoute = getIsMatchingRoute(navItem);
            const linkClasses = classnames('global-nav-drawer__link', {
              'global-nav-drawer__link--active': isMatchingRoute
            });

            return (navItem.hardLink ?? false) ? (
              <a key={navItem.key} href={navItem.route} className={linkClasses}>
                {navItem.name}
              </a>
            ) : (
              <Link
                key={navItem.key}
                to={navItem.route}
                className={linkClasses}
                onClick={(e) => {
                  e.stopPropagation();
                  callTargetedAction({
                    name: DRAWER_SET_DRAWER_VISIBILITY,
                    payload: false,
                    targetStore: 'GlobalNavDrawerStore'
                  });
                }}
              >
                {navItem.name}
              </Link>
            );
          })}
          {isStudent ? (
            <HelpCenterLink className='global-nav-drawer__link' />
          ) : (
            <HelpMenu isForDrawer />
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default GlobalNavDrawer;
